import React from 'react';
import PropTypes from 'prop-types';

import { ZDivider } from '@zanichelli/albe-web-components/react';

import FluidContainer from '../../../layouts/components/fluid-container';
import Spacer from '../../../spacer';

const ExerciseHeading = ({ headingData }) => {
    if (!headingData.upperText && !headingData.lowerText) {
        return null;
    }

    return (
        <FluidContainer paddingBottom={[8, 8, 16]} flexDirection="column" className="interactive-1-sb">
            <span>{headingData.upperText}</span>
            <span>{headingData.lowerText}</span>
            <Spacer size={[8, 8, 16]} />
            <ZDivider />
        </FluidContainer>
    );
};

export const headingDataPropType = PropTypes.shape({
    upperText: PropTypes.string,
    lowerText: PropTypes.string,
});

ExerciseHeading.propTypes = {
    headingData: headingDataPropType,
};

export default ExerciseHeading;
